import { Modal } from "antd";

/**
 * Ant Design confirm dialog. Resolves `true` when the user confirms, `false` otherwise.
 */
export default function confirmModal({
    title,
    content,
    okText,
    cancelText,
    centered = true,
    danger = false,
}) {
    return new Promise((resolve) => {
        Modal.confirm({
            title,
            content,
            okText,
            cancelText,
            centered,
            okButtonProps: danger ? { danger: true } : undefined,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
        });
    });
}
